/**
 * @module
 * @description Javascript specific to the Policies Archive
 */

import state from '../../config/state';
import delegate from 'delegate';
import { on } from '@utils/events';
import * as tools from '@utils/tools';

const el = {
	container: tools.getNodes('page-nav')[0],
	mobileTrigger: tools.getNodes('page-nav-mobile-toggle')[0],
	pageNavWrap: tools.getNodes('page-nav-mobile-wrap')[0],
};

/**
 * Show a particular filter subMenu.
 *
 * @param subMenuEl
 */
const showSubMenu = (subMenuEl) => {
	let menuItem = subMenuEl;
	if (!menuItem.classList.contains('nav-section__list-item--has-children')) {
		menuItem = tools.closest(subMenuEl, '.nav-section__list-item--has-children');
	}
	const button = menuItem.querySelector('[data-js="trigger-child-menu"]');
	const subMenu = menuItem.querySelector('[data-js="child-menu"]');
	menuItem.classList.add('nav-section__list-item--is-active');
	if (subMenu) {
		subMenu.setAttribute('aria-hidden', 'false');
	}
	if (button) {
		button.setAttribute('aria-expanded', 'true');
	}
};

/**
 * Hide a particular submenu.
 *
 * @param subMenuEl
 */
const hideSubMenu = (subMenuEl) => {
	let menuItem = subMenuEl;
	if (!menuItem.classList.contains('nav-section__list-item--has-children')) {
		menuItem = tools.closest(subMenuEl, '.nav-section__list-item--has-children');
	}
	const button = menuItem.querySelector('[data-js="trigger-child-menu"]');
	const subMenu = menuItem.querySelector('[data-js="child-menu"]');
	menuItem.classList.remove('nav-section__list-item--is-active');
	if (subMenu) {
		subMenu.setAttribute('aria-hidden', 'true');
	}
	if (button) {
		button.setAttribute('aria-expanded', 'false');
	}
};

/**
 * Loop through and hide all submenus.
 */
const hideSubMenus = () => {
	const menuItems = tools.getNodes('.nav-section__list-item--has-children', true, el.container, true);
	menuItems.forEach((menuItem) => hideSubMenu(menuItem));
};

/**
 * Toggle a particular submenu on click.
 *
 * @param e
 */
const toggleSubMenu = (e) => {
	const menu = tools.closest(e.delegateTarget, '.nav-section__list-item');

	if (menu.classList.contains('child_open')) {
		showSubMenu(e.delegateTarget);
	} else {
		hideSubMenu(e.delegateTarget);
	}
};

/**
 * Show any sub menus that contain a link to the current page.
 */
const handleSubMenus = () => {
	const menuItems = tools.getNodes('.nav-section__list-item--has-children', true, el.container, true);

	menuItems.forEach((item) => {
		if (item.classList.contains('nav-section__list-item--is-current-parent')) {
			showSubMenu(item);
		}
	});
};

/**
 * For desktop, set the default display state of the page nav subMenus based on if the submenu contains a link to the current page.
 */
const initSubMenus = () => {
	if (state.is_mobile) {
		return;
	}

	handleSubMenus();
};

/**
 * Hide the page nav sidebar.
 */
const hidePageNav = () => {
	el.container.classList.remove('page-nav__mobile--visible');
	if (el.mobileTrigger) {
		el.mobileTrigger.innerHTML = el.mobileTrigger.dataset.showLabel;
		el.mobileTrigger.setAttribute('aria-expanded', 'false');
	}
	el.pageNavWrap.setAttribute('aria-hidden', 'true');

	hideSubMenus();
};

/**
 * Show the page nav sidebar.
 */
const showPageNav = () => {
	el.container.classList.add('page-nav__mobile--visible');
	if (el.mobileTrigger) {
		el.mobileTrigger.innerHTML = el.mobileTrigger.dataset.hideLabel;
		el.mobileTrigger.setAttribute('aria-expanded', 'true');
	}
	el.pageNavWrap.setAttribute('aria-hidden', 'false');

	handleSubMenus();
};

/**
 * @function togglePageNav
 * @description Toggle all sub menus on mobile viewports
 */
const togglePageNav = () => {
	if (el.container.classList.contains('page-nav__mobile--visible')) {
		hidePageNav();
	} else {
		showPageNav();
	}
};

/**
 * Handle the initial page nav sidebar state and resize events.
 */
const handleMobileToggle = () => {
	if (state.is_mobile) {
		return;
	}

	showPageNav();
};

/**
 * @function bindEvents
 * @description Bind the events for this module here.
 */

const bindEvents = () => {
	delegate(el.container, '[data-js="page-nav-mobile-toggle"]', 'click', togglePageNav);
	delegate(el.container, '[data-js="trigger-child-menu"]', 'click', toggleSubMenu);

	on(document, 'ur_core/resize_executed', handleMobileToggle);
};

/**
 * @function init
 * @description Kick off this modules functions
 */

const init = () => {
	if (!el.container) {
		return;
	}

	bindEvents();
	handleMobileToggle();
	initSubMenus();
};

import $ from 'jquery';
window.$ = $;
window.jQuery = $;
const sidebar_btn = $('.nav-section__action--has-children');
$(sidebar_btn).click(function () {
	$(this).parent().toggleClass('child_open');
});

$(sidebar_btn).on('keyup', function (e) {
	if (e.key === 'Escape') $(this).click();
});

const button = $('.main_title');
const menu = $('.title-menu');

$(button).click(function () {
	if (this.classList.contains('open')) {
		$(this).removeClass('open');
		$(this).attr('aria-expanded', 'false');
		$(menu).removeClass('open');
		$(menu).attr('aria-hidden', 'true');
	} else {
		$(this).addClass('open');
		$(this).attr('aria-expanded', 'true');
		$(menu).addClass('open');
		$(menu).attr('aria-hidden', 'false');
	}
});

const sub_button = $('.sub_title');
const sub_menu = $('.sub-menu');

$(sub_button).click(function () {
	if (this.classList.contains('open')) {
		$(this).removeClass('open');
		$(this).attr('aria-hidden', 'false');
		$(sub_menu).removeClass('open');
		$(sub_menu).attr('aria-hidden', 'true');
	} else {
		$(this).addClass('open');
		$(this).attr('aria-expanded', 'true');
		$(sub_menu).addClass('open');
		$(sub_menu).attr('aria-hidden', 'false');
	}
});

export default init;
